import { MeshLoadCancelledError } from '@/plugins/mesh/errors'

interface Waiter {
  signal?: AbortSignal
  resolve: (release: () => void) => void
  reject: (error: unknown) => void
  abort: () => void
}

/** 单次清单共享的图片读取/解码额度；取消等待不占用后续任务额度。 */
export class MeshTextureTaskPool {
  private active = 0
  private readonly pending: Waiter[] = []

  constructor(private readonly limit: number) {
    if (!Number.isInteger(limit) || limit < 1) throw new Error('纹理任务额度必须为正整数')
  }

  acquire(signal?: AbortSignal): Promise<() => void> {
    return new Promise((resolve, reject) => {
      const waiter: Waiter = {
        signal,
        resolve,
        reject,
        abort: () => {
          const index = this.pending.indexOf(waiter)
          if (index >= 0) this.pending.splice(index, 1)
          signal?.removeEventListener('abort', waiter.abort)
          reject(new MeshLoadCancelledError('(清单纹理任务)', { cause: signal?.reason }))
        },
      }
      if (signal?.aborted) {
        waiter.abort()
        return
      }
      this.pending.push(waiter)
      signal?.addEventListener('abort', waiter.abort, { once: true })
      this.drain()
    })
  }

  private drain(): void {
    while (this.active < this.limit && this.pending.length > 0) {
      const waiter = this.pending.shift()!
      waiter.signal?.removeEventListener('abort', waiter.abort)
      this.active++
      let released = false
      waiter.resolve(() => {
        if (released) return
        released = true
        this.active--
        this.drain()
      })
    }
  }
}
